var ABN_REGEXP = /^[0-9]{11}$/;
var ACN_REGEXP = /^[0-9]{9}$/;

function isValidAbn(viewValue) {
    if (ABN_REGEXP.test(viewValue)) {
        var weightings = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
        var sum = 0;
        var local;
        for(var i=0; i<viewValue.length; i++) {
            local = Number(viewValue.charAt(i));
            // You must subtract 1 from the first digit
            if(i===0) {
                local--;
            }
            sum += local*weightings[i];
        }
        return ((sum%89) === 0);
    }
    else {
        return false;
    }
}

function isValidAcn(viewValue) {
    if (ACN_REGEXP.test(viewValue)) {
        var weightings = [8, 7, 6, 5, 4, 3, 2, 1];
        var sum = 0;
        for(var i=0; i<weightings.length; i++) {
            sum += weightings[i] * Number(viewValue.charAt(i));
        }
        var check = (10 - (sum % 10)) % 10;
        return (viewValue.charAt(8) == check);
    }
    else {
        return false;
    }
}

function abnOrAcn() {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$validators.abnOrAcn = function(modelValue, viewValue) {

                if (ctrl.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }

                return (isValidAbn(viewValue) || isValidAcn(viewValue));
                
            };
        }
    };
}

export default angular.module('abnOrAcn', []).directive('abnOrAcn', abnOrAcn).name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/abnOrAcn.directive.js
 **/